import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c('toolbar',{attrs:{"mode":"report","title":_vm.report ? _vm.report.name : 'Edit',"view":"list"}}),(_vm.loading)?_c(VProgressLinear,{attrs:{"indeterminate":""}}):_c('report-form',{attrs:{"report":_vm.report,"working":_vm.working},on:{"submit":_vm.onSubmit,"cancel":function($event){return _vm.$router.push({ name: 'reportList' })}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }